var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4002 21.5999C17.7021 21.5999 22.0002 17.3018 22.0002 11.9999C22.0002 6.69797 17.7021 2.3999 12.4002 2.3999C7.09824 2.3999 2.80017 6.69797 2.80017 11.9999C2.80017 17.3018 7.09824 21.5999 12.4002 21.5999ZM16.1179 11.2391C16.6918 10.9077 16.8885 10.1738 16.5571 9.59988C16.2257 9.02593 15.4918 8.82928 14.9179 9.16065L8.6825 12.7607C8.10855 13.092 7.9119 13.8259 8.24327 14.3999C8.57464 14.9738 9.30855 15.1705 9.8825 14.8391L16.1179 11.2391Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableCircle);
export default __webpack_public_path__ + "static/media/disable-circle.779e8d8101bb64434d414a21be8d943e.svg";
export { ForwardRef as ReactComponent };